import { combineReducers, createStore } from 'redux';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

import { applyReducer } from './apply';
import { ApplyStateInterface } from './apply/state';
import { buildingReducer } from './building';
import { BuildingStateInterface } from './building/state';
import { searchReducer } from './search';
import { SearchStateInterface } from './search/state';
import { sensitiveReducer } from './sensitive';
import { sessionReducer } from './session';
import { AppState } from './state';
import { unitReducer } from './unit';
import { UnitStateInterface } from './unit/state';

const persistConfig = {
  blacklist: ['sensitive'],
  key: 'root',
  storage,
};

export const reducers = combineReducers({
  apply: applyReducer,
  building: buildingReducer,
  search: searchReducer,
  sensitive: sensitiveReducer,
  session: sessionReducer,
  unit: unitReducer,
});

const persistedReducer = persistReducer(persistConfig, reducers);

const enhancers: any = () => void 0;
export const store = createStore(
  persistedReducer,
  enhancers(),
  (window as any).__REDUX_DEVTOOLS_EXTENSION__ &&
    (window as any).__REDUX_DEVTOOLS_EXTENSION__()
);

export const storeSelector = (key: string, state: AppState) => state[key] || {};
export const buildingStoreSelector = (state: AppState) =>
  storeSelector('building', state) as BuildingStateInterface;
export const unitStoreSelector = (state: AppState) =>
  storeSelector('unit', state) as UnitStateInterface;
export const searchStoreSelector = (state: AppState) =>
  storeSelector('search', state) as SearchStateInterface;
export const applyStoreSelector = (state: AppState) =>
  storeSelector('apply', state) as ApplyStateInterface;
